export default __webpack_public_path__ + "static/media/authentication.e9633564.svg";